import React, {useEffect} from "react"
import {LoadingOutlined} from "@ant-design/icons";
import {fetchWorkbooks, selectWorkbook, selectWorkbooks} from "./storyboardSlice";
import {useAppDispatch, useAppSelector} from "../../hooks";
import _ from "lodash";
import {StoryboardPreview} from "./StoryboardPreview";

const StoryboardList = () => {

    const dispatch = useAppDispatch()
    const selectedWorkbook = useAppSelector(selectWorkbook)
    const workbooks = useAppSelector(selectWorkbooks)

    useEffect(() => {
        if (_.isUndefined(workbooks)) {
            dispatch(fetchWorkbooks())
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const renderWorkbooks = () => {
        if (workbooks) {
            return workbooks.map(i => {
                return <StoryboardPreview
                    key={i.workbookId}
                    workbook={i}
                    isWithinDrawer
                    selected={selectedWorkbook?.workbookId === i.workbookId}
                />
            })
        } else {
            return <LoadingOutlined/>
        }
    }

    return (<div>{renderWorkbooks()}</div>);

}

export default StoryboardList